import { mapPromotionType } from 'hooks'
import { PROMOTION_TYPE, RnbCalculatorPayload } from 'typings'
import { parseCron } from 'ui'
import type { Promotion, PromotionBase } from '../../../typings'
import { mapBuyAndWin } from './promotions/buyAndWin'
import { mapBuyTogether } from './promotions/buyTogether'
import { mapCampaign } from './promotions/campaign'
import { mapMoreForLess } from './promotions/moreForLess'
import { mapProgressiveDiscount } from './promotions/progressiveDiscount'
import { mapRegular } from './promotions/regular'
import { mapAdditionalInformation } from './storefront'

export function mapPromotionBase(data: RnbCalculatorPayload): PromotionBase {
  return {
    id: data.idCalculatorConfiguration,
    type: mapPromotionType(data.type),
    general: {
      active: data.isActive,
      name: data.name,
      description: data.description,
    },
    scheduling: {
      start: new Date(data.beginDateUtc),
      end: data.endDateUtc ? new Date(data.endDateUtc) : undefined,
      recurrence: parseCron(data.recurrencyCrons?.[0], data.newOffset),
    },
    storefront: {
      highlight: Boolean(data.isFeatured),
      additionalInformation: mapAdditionalInformation(data.generalValues),
    },
  }
}

export function mapPromotion(data: RnbCalculatorPayload): Promotion {
  switch (data.type) {
    case PROMOTION_TYPE.BUY_TOGETHER:
      return mapBuyTogether(data)
    case PROMOTION_TYPE.BUY_AND_WIN:
      return mapBuyAndWin(data)
    case PROMOTION_TYPE.MORE_FOR_LESS:
      return mapMoreForLess(data)
    case PROMOTION_TYPE.PROGRESSIVE:
      return mapProgressiveDiscount(data)
    case PROMOTION_TYPE.REGULAR:
      return mapRegular(data)
    case PROMOTION_TYPE.CAMPAIGN:
      return mapCampaign(data)
    default:
      throw new Error(`Promotion type ${data.type} not supported`)
  }
}
